<div *ngIf="(isCategoryPage && facetsList?.length) || isCmsPage || (!showContentTab && !isCategoryPage ) ||
(showContentTab && cmsFacets?.length)"
     class="no-gutters mb-search-filter cursor-pointer py-1"
     [ngClass]="{'w-auto float-right text-nowrap' : !isFacetsVisible}"
     data-cy="mb-search-filter"
>
  <div class="mb-search-filter-header pl-2 pr-4">
    <div [ngClass]="{'d-none d-xl-block d-md-block' : isFacetsVisible}"
         (click)="toggleContentWidth()"
    >
      <img src="../../../../assets/images/Icon_settings.svg"
           class="mx-2 my-2 mb-search-item-icons"
           alt="Show filter pane icon"
           title="Filter pane Icon"
           aria-label="Filter pane"
           data-cy="mb-search-filter-icon"
      />
      <span class="hidden-xs hidden-sm pr-sm-2">
          {{ (isFacetsVisible ? 'searchFilterPane.showLess' : 'searchFilterPane.showMore') | mbTranslate }}
      </span>
    </div>
  </div>

  <ng-container *ngIf="isFacetsVisible">
    <div class="mb-search-filter-mobile-title d-sm-flex d-md-none d-lg-none">
      <div class="mb-search-facets-mobile-header-title">{{'searchFilterPane.mobileHeaderTitle' | mbTranslate}}</div>
      <div class="mb-search-filter-mobile-title-close-button"
           (click)="toggleContentWidth()"
      >
      </div>
    </div>
    <div class="mb-search-facets-list px-4 pt-1 pb-4">
      <ng-container *ngIf="isCategoryPage else isSearchPageBlock">
        <mb-facet-list [facetsList]="facetsList"></mb-facet-list>
      </ng-container>

      <ng-template #isSearchPageBlock>
        <mb-facet-list *ngIf="!isCmsPage && !showContentTab"></mb-facet-list>
        <mb-cms-facet-list *ngIf="isCmsPage || showContentTab"
                           [jobs]="jobs"
        ></mb-cms-facet-list>
      </ng-template>
    </div>
  </ng-container>
</div>
